const preScanEN = {
    "form": {
        "modal": {
            "preScanResults": {
                "header": "Pre Scan Results",
                "body": {
                    "description": "Following results have been found after performing scan for this release, please check these in detail:",
                    "table": {
                        "column": {
                            "trackName": "Track Name",
                            "type": "Type",
                            "title": "Title",
                            "artists": "Artists",
                            "album": "Album",
                            "label": "Label",
                            "releaseDate": "Release Date",
                            "score": "Score (%)"
                        },
                    },
                    "label": {
                        "flaggedTracks": "Flagged Tracks",
                        "music": "Music",
                        "cover": "Cover",
                        "signDeclaration": "Please sign the declaration in order to proceed further.",
                        "cancelRelease": "I want to cancel this release.",
                        "approveRelease": {
                            "point1": "I want to approve this release because the results shown are 100% identical to my own release / transferring from the previous distributor.",
                            "point2": "I hereby solemnly declare, under penalty of perjury, that all content I provide is owned by my company or me, or that I hold full and valid rights and licences necessary for its use, distribution, and submission.",
                            "point3": "I acknowledge and accept that I am fully responsible for any legal consequences arising from the submission of such content, including but not limited to legal proceedings, claims, costs, and fees.",
                            "point4": "I further understand and agree that my personal data, including KYC information and any other relevant data, may be shared with authorised partners, digital service providers (DSPs), third parties involved in the processing of such content, as well as courts, regulatory authorities, and law enforcement agencies in the event of any claim, dispute, or legal requirement.",
                            "point5": "I understand and agree that Music Linkreserves the right to immediately terminate my agreement, without any compensation or further obligation, if it is proven that I have misused this form or if any part of my declaration is false, misleading, or misrepresented.",
                        },
                        "noFlaggedTracks": "No flagged tracks detected in the pre-scan, you can proceed with next steps!"
                    },
                    "help_text": {
                    },
                },
                "button": {
                    "submit": "Submit",
                    "close": "Close"
                }
            },
            "performScan": {
                "header": "Perform Pre-Scan",
                "body": "Please confirm that you want to perform pre-scan for this release.",
                "button": {
                    "cancel": "Cancel",
                    "performScan": "Perform Scan"
                }
            }
        },
        "message": {
            "releaseDistributionCancelled": "You have cancelled the distribution of the release, therefore it has been taken down.",
            "admin_pending": "Your declaration is pending admin review for further action.",
            "admin_approved": "Your request to distribute your release has been approved by our admin team. The release has been successfully verified. We appreciate your diligence in ensuring accuracy and compliance. The release will proceed to all stores as planned. Thank you for your attention to detail and adherence to our standards.",
            "admin_rejected": "Your request to distribute your release has been rejected. After careful review, the request does not meet our approval requirements. We recommend re-evaluating the content and ensuring all conditions and legal implications are addressed. Thank you for your understanding and cooperation.",
            "scanInProgress": "Scan in progress, please wait for the scan to complete.",
            "releaseMustBeReady": "Release must be in Ready status to perform pre scan.",
            "errorSubmittingDeclaration": "Error occurred while submitting admin pre scan declaration.",
        }
    }
};

export default preScanEN;